<template>
    <div>
        <div class="flex flex-wrap -mx-2 text-xs border-grey-lighter mb-4">
          <div class="w-full lg:w-1/2 px-2 mb-4">
            <label class="mr-1">First Name:</label><i class="tooltip-container fas fa-info-circle text-blue">
              <div class="absolute border border-bg-primary p-2 bg-white shadow z-10 rounded text-xs normal-case mt-1 tooltip-msg pointer-events-none">
                <span class="text-black font-sans">Visit your Ecosystem profile to update this information.</span>
              </div>
            </i>
            <p class="text-sm mt-2">{{ value.first_name }}</p>
          </div>

          <div class="w-full lg:w-1/2 px-2 mb-4">
            <label class="mr-1">Surname:</label><i class="tooltip-container fas fa-info-circle text-blue">
              <div class="absolute border border-bg-primary p-2 bg-white shadow z-10 rounded text-xs normal-case mt-1 tooltip-msg pointer-events-none">
                <span class="text-black font-sans">Visit your Ecosystem profile to update this information.</span>
              </div>
            </i>
            <p class="text-sm mt-2">{{ value.surname }}</p>
          </div>
        </div>
        <div class="flex flex-wrap -mx-2 text-xs border-grey-lighter mb-4">
          <div class="w-full px-2 mb-4">
            <label class="mr-1">Email Address:</label><i class="tooltip-container fas fa-info-circle text-blue">
              <div class="absolute border border-bg-primary p-2 bg-white shadow z-10 rounded text-xs normal-case mt-1 tooltip-msg pointer-events-none">
                <span class="text-black font-sans">Visit your Ecosystem profile to update this information.</span>
              </div>
            </i>
            <p class="text-sm mt-2">{{ value.email }}</p>
          </div>
        </div>
        <div class="flex flex-wrap -mx-2 text-xs border-grey-lighter mb-4">
          <div class="w-full px-2 mb-4">
            <label class="mr-1" for="phone">Landline Phone Number:</label><i class="tooltip-container fas fa-info-circle text-blue">
              <div class="absolute border border-bg-primary p-2 bg-white shadow z-10 rounded text-xs normal-case mt-1 tooltip-msg pointer-events-none">
                <span class="text-black font-sans">Please enter your landline number</span>
              </div>
            </i>
            <input type="text" :disabled="value.userApproval.status === 0" id="phone" v-model="value.phone" class="block w-full border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm">
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('phone')" v-text="errorBag.get('phone')"></small>
          </div>
          <div class="w-full px-2 mb-4">
            <label class="mr-1" for="phone">Mobile Phone Number:</label><i class="tooltip-container fas fa-info-circle text-blue">
              <div class="absolute border border-bg-primary p-2 bg-white shadow z-10 rounded text-xs normal-case mt-1 tooltip-msg pointer-events-none">
                <span class="text-black font-sans">Please enter your mobile number</span>
              </div>
            </i>
            <input type="text" :disabled="value.userApproval.status === 0" id="mobile" v-model="value.mobile" class="block w-full border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm">
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('mobile')" v-text="errorBag.get('mobile')"></small>
          </div>
           <div class="w-full lg:w-1/2 px-2 mb-4">
            <label class="mr-1" for="position">Position:</label><i class="tooltip-container fas fa-info-circle text-blue">
              <div class="absolute border border-bg-primary p-2 bg-white shadow z-10 rounded text-xs normal-case mt-1 tooltip-msg pointer-events-none">
                <span class="text-black font-sans">Please enter position</span>
              </div>
            </i>
            <input type="text" :disabled="value.userApproval.status === 0" id="position" v-model="value.position" class="block w-full border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm">
          </div>
          <div v-if="system.external_data.bios === true" class="w-full lg:w-1/2 px-2 mb-4">
            <label class="mr-1" for="whatsapp_account">WhatsApp:</label><i class="tooltip-container fas fa-info-circle text-blue">
              <div class="absolute border border-bg-primary p-2 bg-white shadow z-10 rounded text-xs normal-case mt-1 tooltip-msg pointer-events-none">
                <span class="text-black font-sans">Please enter your WhatsApp</span>
              </div>
            </i>
            <input type="text" :disabled="value.userApproval.status === 0" id="whatsapp_account" v-model="value.userApproval.whatsapp_account" class="block w-full border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm">
          </div>
        </div>
        <div v-if="system.external_data.bios === true" class="flex flex-wrap -mx-2 text-xs border-grey-lighter mb-4">
          <div class="w-full lg:w-1/2 px-2 mb-4">
            <label class="mr-1" for="facebook_messenger">Facebook Messenger:</label><i class="tooltip-container fas fa-info-circle text-blue">
              <div class="absolute border border-bg-primary p-2 bg-white shadow z-10 rounded text-xs normal-case mt-1 tooltip-msg pointer-events-none">
                <span class="text-black font-sans">Please enter Facebook messenger</span>
              </div>
            </i>
            <input type="text" :disabled="value.userApproval.status === 0" id="facebook_messenger" v-model="value.userApproval.facebook_messenger" class="block w-full border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm">
          </div>
          <div v-if="system.external_data.bios === true" class="w-full lg:w-1/2 px-2 mb-4">
            <label class="mr-1" for="spoken_languages">Spoken languages:</label><i class="tooltip-container fas fa-info-circle text-blue">
              <div class="absolute border border-bg-primary p-2 bg-white shadow z-10 rounded text-xs normal-case mt-1 tooltip-msg pointer-events-none">
                <span class="text-black font-sans">Please enter spoken languages</span>
              </div>
            </i>
            <input type="text" :disabled="value.userApproval.status === 0" id="spoken_languages" v-model="value.spoken_languages" class="block w-full border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm">
          </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'personalDetail',
  props: ['value', 'errorBag', 'network'],
  watch: {
    value: {
      handler (val) {
        this.$emit('input', this.value)
      },
      deep: true
    }
  },
  computed: {
    ...mapState([ 'system' ])
  }
}
</script>
